<div class="container pt-6">
    <!-- Skeleton Loader para servicios -->
    <ng-container *ngIf="!servicesData?.services?.list || servicesData?.services?.list.length === 0">
        <div class="row">
            <div class="col-md-11 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center">
                <div class="skeleton skeleton-title" style="height: 40px; margin: 0 auto 1.5rem auto;"></div>
                <div class="skeleton skeleton-paragraph" style="height: 24px; margin: 0 auto 2.5rem auto; width: 60%;"></div>
            </div>
        </div>
        <div class="service-container row gx-md-8 gy-8 text-center mb-14 mb-md-17">
            <div class="col-md-6 col-lg-3" *ngFor="let i of [1,2,3,4]">
                <div class="pointer">
                    <div class="skeleton skeleton-img" style="width: 80px; height: 80px; margin: 0 auto 1.5rem auto; border-radius: 16px;"></div>
                    <div class="skeleton skeleton-title" style="height: 24px; width: 70%; margin: 0 auto 1rem auto;"></div>
                    <div class="skeleton skeleton-paragraph" style="height: 18px; width: 90%; margin: 0 auto 0.5rem auto;"></div>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Contenido real -->
    <ng-container *ngIf="servicesData?.services?.list && servicesData?.services?.list.length > 0">
        <div class="row">
            <div class="col-md-11 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center">
                <h2 class="display-2 mb-4 default-pattern-color">{{ servicesData.services?.title }}</h2>
                <p class="lead fs-lg mb-11">{{ servicesData.services?.description }}</p>
            </div>
        </div>
        <div class="service-container row gx-md-8 gy-8 text-center mb-14 mb-md-17">
            <div class="col-md-6 col-lg-3" *ngFor="let service of servicesData?.services?.list; let i = index">
                <div class="pointer" (click)="goToService(service?.view?.link, service?.view?.id)">
                    <div class="svg-bg svg-bg-lg bg-white rounded-xl shadow-xl mb-6">
                        <img dynamicImage *ngIf="service?.img" [baseImageSrc]="service?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.xxs, IMAGES_RESOLUTIONS.xs]"class="serv-icon" alt="serviceImage" /></div>
                    <h3 class="default-pattern-color">{{ service?.title }}</h3>
                    <p class="mb-3">{{ service?.description }}
                        <span class="see-more-btn" >{{'landing.see_more' | translateWithKeys}}</span>
                    </p>
                </div>
            </div>
        </div>
    </ng-container>
</div>
